

import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

@Component({
  selector: '[mwc-input-group-slot]',
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span mwc-icon [mwcType]="icon" *ngIf="icon"></span>
    <ng-container *mwcStringTemplateOutlet="template">{{ template }}</ng-container>
    <ng-content></ng-content>
  `,
  host: {
    '[class.mwc-input-group-addon]': `type === 'addon'`,
    '[class.mwc-input-prefix]': `type === 'prefix'`,
    '[class.mwc-input-suffix]': `type === 'suffix'`
  }
})
export class MwcInputGroupSlotComponent {
  @Input() icon?: string | null = null;
  @Input() type: 'addon' | 'prefix' | 'suffix' | null = null;
  @Input() template?: string | TemplateRef<void> | null = null;
}
